import axios from "axios";
import { sessionAuthorization } from "./sessionAuthorization";

const baseURL = process.env.REACT_APP_DASHBOARDS_API_URL;

export const dashboardsClient = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

dashboardsClient.interceptors.request.use(sessionAuthorization);

export default dashboardsClient;
